import React from 'react'
import {
  PieChart,
  Pie,
  ResponsiveContainer,
  Cell,
} from 'recharts'
import _ from 'lodash'

import Comfort from 'helpers/Comfort'
import Color from 'helpers/Color'

const TemperaturePie = ({ data, dataKey }) => {
  if (data.length === 0) return <div />

  // Remove items without a vlue (or a zero value) for the given key
  const filtered = _.filter(data, dataKey)

  // Generate an object with the counts for each comfort level
  const comfortCounts = _.countBy(filtered.length ? filtered : data, item => (
    Comfort.fromTemperature(item[dataKey])
  ))

  const chartData = Object.entries(comfortCounts).map(([comfort, count]) => ({
    name: comfort,
    value: count,
    color: Color.fromComfort(comfort),
  }))

  return (
    <ResponsiveContainer height={280}>
      <PieChart>
        <Pie
          data={chartData}
          label={ChartLabel}
          labelLine={false}
          innerRadius={'60%'}
          outerRadius={'100%'}
          dataKey='value'
          isAnimationActive={false}
          minAngle={10}
        >
          { chartData.map(item =>
            <Cell key={item.name} fill={item.color} />
          )}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  )
}

const ChartLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.5
  const x = cx + radius * Math.cos(-midAngle * Math.PI / 180)
  const y = cy + radius * Math.sin(-midAngle * Math.PI / 180)

  return (
    <text x={x} y={y} fill='white' textAnchor='middle' dominantBaseline='central'>
      {`${Math.round(percent * 1000) / 10}%`}
    </text>
  )
}

export default TemperaturePie



// WEBPACK FOOTER //
// ./src/components/UI/Chart/TemperaturePie.jsx